import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { imageLocation } from '../config/constants';
import '../style/projectSample.css';

export class ProjectSample extends Component {
	render() {
		return (
			<div className="projectSample">
				<Link to={'/project/' + this.props.project.name}>
					<div
						className="previewImage"
						style={{
							backgroundImage:
                                `url(${imageLocation}projects/${this.props.project.preview.replace(/ /g, '%20').toLowerCase()})`
						}}
					/>
					<p>{this.props.project.name} </p>
					<p>{this.props.project.location} </p>
				</Link>
			</div>
		);
	}
}

export class MobileProjectSample extends Component {
	render() {
		return (
			<div className="mobileProjectSample">
				<Link to={'/project/' + this.props.project.name}>
					<div
						className="previewImage"
						style={{
							backgroundImage:
								`url(${imageLocation}projects/${this.props.project.preview.replace(/ /g, '%20').toLowerCase()})`
						}}
					/>
					<p>{this.props.project.name} </p>
					<p>{this.props.project.location} </p>
				</Link>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/projectSample.js